

/// <reference path="BusinessLog.ts" />

// Generated class SeasonEndLog_ManagedObject

class SeasonEndLog_ManagedObject extends BusinessLog
{

    // Property: endDate
    set endDate(value:Date) {
        this.setValueForKey(value, 'endDate');
    }
    get endDate():Date {
        return this.valueForKey('endDate');
    }
    set endDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'endDate');
    }
    get endDatePrimitiveValue():Date {
        return this.primitiveValueForKey('endDate');
    }
    // Relationship: license
    set license(value:License) {
        this.setValueForKey(value, 'license');
    }
    get license():License {
        return this.valueForKey('license') as License;
    }
}
